import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import router from './router'
import store from './store'
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import { isAuth } from '@/utils'
import VueCookie from 'vue-cookie' 
Vue.use(VueCookie)
Vue.config.productionTip = false
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale })

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
Vue.prototype.isAuth = isAuth     // 权限方法


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
